import React from 'react';

const apiKey = '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i';
const createReactClass = require('create-react-class');

const getSizeClass = (photoSize, idx) => {
  if (photoSize === 'large_square') {
    return 'lg-sq';
  }
  const pos = idx % 7;
  return pos < 4 ? 'sm' : 'lg';
};

const PhotosFeedItem = createReactClass({
  getInitialState() {
    return {
      loading: true,
      ref: React.createRef()
    };
  },
  handlePhotoClick(e) {
    e.preventDefault();

    this.props.openLightbox(this.props.idx);
  },
  handleServerPhotoLoaded() {
    this.setState({ loading: false });
  },
  componentDidMount() {
    const img = this.state.ref.current;
    if (img && img.complete) {
      this.handleServerPhotoLoaded();
    }
  },
  render() {
    const { id, trailName, locationName } = this.props.item;

    const alt = [trailName, locationName].filter(part => !!part).join(' - ');
    const hash = this.props.item.photoHash;
    const photoSize = this.props.photoSize ? this.props.photoSize : 'large_square';
    const fallbackPhotoUrl = `/api/alltrails/photos/${id}/image?size=${photoSize}&api_key=${apiKey}`;
    const fallbackBigPhotoUrl = `/api/alltrails/photos/${id}/image?size=extra_large&api_key=${apiKey}`;
    let photoUrl;
    let bigPhotoUrl;
    if (id && hash) {
      const photoRoot = 'https://cdn-assets.alltrails.com/uploads/photo/image/';
      photoUrl = `${photoRoot + id}/${photoSize}_${hash}.jpg`;
      bigPhotoUrl = `${photoRoot + id}/extra_large_${hash}.jpg`;
    } else {
      photoUrl = fallbackPhotoUrl;
      bigPhotoUrl = fallbackBigPhotoUrl;
    }
    let shouldFallback = true;
    const addFallbackSrc = ev => {
      if (shouldFallback) {
        ev.target.src = fallbackPhotoUrl;
        ev.target.onerror = null;
      }
      shouldFallback = false;
    };
    return (
      <a
        className={`photo-item gallery ${getSizeClass(photoSize, this.props.idx)}`}
        data-credit-link=""
        data-photo-id={id}
        key={`trail-photo-${id}`}
        onClick={e => this.handlePhotoClick(e)}
        href={bigPhotoUrl}
        rel={this.props.rel}
      >
        <img
          alt={alt}
          className="trail-photo lazyload"
          id={`trail-photo-${id}`}
          onError={addFallbackSrc}
          onLoad={() => {
            this.setState({ loading: false });
          }}
          ref={this.state.ref}
          data-src={photoUrl}
        />
      </a>
    );
  }
});

const PhotosFeedFakeItem = ({ photoSize, idx }) => {
  return <div key={`fakePhoto-${idx}`} className={`photo-item ${getSizeClass(photoSize, idx)}`} />;
};

export { PhotosFeedItem, PhotosFeedFakeItem, apiKey };
